import { addIOListener } from '../common';

export const onSocketReconnect = addIOListener('reconnect');
